import Component from '../core/Component';
import $ from 'jquery';
import lightGallery from 'lightgallery';

export default class Gallery extends Component
{
    constructor($element)
    {
        super($element);
    }

    prepare()
    {
        this.$element.lightGallery({
            download: false,
            autoplayControls: false,
            fullScreen: false,
            zoom: false,
            hash: false,
            enableTouch: false,
            counter: false,
            selector: 'a'
        });
    }
}


// WEBPACK FOOTER //
// ./components/Gallery.js